import { axios } from "../config/axios";

const endPoint = '/project/unlock-candidate';

const unlockCandidateByIds = (projectMasterId, candidateIds) => {
    return axios.post(`${endPoint}/unlock-candidate-by-ids`, {
        projectMasterId: projectMasterId,
        candidateIds: candidateIds,
    });
}

const getListByProjectMasterWithPagination = async (projectMasterId, examHallId, searchTerm, pageNumber, limit, status = null) => {
    return axios.post(`${endPoint}/list-requested-by-project-master-with-pagination`, {
        projectMasterId: projectMasterId,
        examHallId: examHallId ?? 0,
        search: searchTerm,
        page: pageNumber,
        limit: limit,
        status: status,
    });
}

const approveRequestedCandidateUnlock = (candidateUnlockIds) => {
    return axios.post(`${endPoint}/approve-candidate-unlock`, { candidateUnlockIds });
}

const rejectRequestedCandidateUnlock = (candidateUnlockIds) => {
    return axios.post(`${endPoint}/reject-candidate-unlock`, { candidateUnlockIds });
}

export {
    unlockCandidateByIds,
    getListByProjectMasterWithPagination,
    approveRequestedCandidateUnlock,
    rejectRequestedCandidateUnlock,
}